import React from "react";
import chunk from "lodash/chunk";
import { WidgetBox, Link, Action } from "../components";
import { DomParser } from "../utils/dom-parser";
import { renderDate } from "../utils/text-display";

const YourTasks = ({ title = "Your tasks" }) => {
    const parseDataFromDOM = () => {
        const domParser = new DomParser(
            "table[summary='Your Tasks Content'] > tbody > tr > td"
        );
        const columns = domParser.columns;
        return chunk(columns, 2).map(row => {
            const [td1, td2] = row;
            return {
                link: domParser.singleAnchor(td1),
                dueDate: domParser.dateSpan(td2)
            };
        });
    };

    const data = parseDataFromDOM();

    let titleLink = null;
    let titleLinkEl = document.querySelector(
        "div[data-tag='pnlTasks'] a.titleLink"
    );

    if (titleLinkEl) {
        titleLink = titleLinkEl.getAttribute("href");
    }

    return (
        <WidgetBox
            title={title}
            icon="clipboard"
            noPadding
            titleLink={titleLink}
        >
            <div style={{ padding: "0px 45px 5px 45px" }} className="v-list">
                {data.map((o, i) => (
                    <div key={i} className="v-list-item">
                        <Action classes="v-list-item__title" {...o.link} />
                        <p className="v-list-item__date">
                            {renderDate(o.dueDate, "Due date: ")}
                        </p>
                    </div>
                ))}
            </div>
            {titleLink && (
                <div style={{ padding: "0px 45px 25px 45px" }}>
                    <Link text="See all tasks" url={titleLink} />
                </div>
            )}
        </WidgetBox>
    );
};

export default YourTasks;



// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/cornerstone-widget-block/widgets/your-tasks.js